import { AxiosError } from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useClickAway } from 'react-use';
import { usePostManualsUpdate } from '../../../api/manual/manual';
import { ErrorInfo, Manual } from '../../../api/model';
import { useDefaultOptions } from '../../../hooks/api';
import useContextMenu from '../../../hooks/useContextMenu';
import Modal from '../../modules/Modal';

type Props = {
  manual: Manual;
  onSearch: () => void;
};

function ManualComment({ manual, onSearch }: Props) {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);
  const { points, setPoints } = useContextMenu();
  const [contextOpen, setContextOpen] = useState(false);
  const [isModal, setIsModal] = useState(false);

  const ref = useRef(null);
  useClickAway(ref, () => {
    setContextOpen(false);
  });

  const handleContextMenu = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e.preventDefault();
    setContextOpen(true);
  };

  const handleClose = () => {
    setIsModal(false);
    setContextOpen(false);
  };

  const { register, handleSubmit } = useForm<Manual>({ defaultValues: { comment: manual.comment } });

  const { mutateAsync, isSuccess } = usePostManualsUpdate<AxiosError<ErrorInfo>, unknown>(options);

  const onSubmit = (data: Manual) => {
    const postManuals = async () => {
      await mutateAsync({ data: { manual_id: manual.manual_id, comment: data.comment } });
    };
    void postManuals();
  };

  useEffect(() => {
    if (isSuccess) {
      onSearch();
      handleClose();
    }
  }, [isSuccess, onSearch]);

  return (
    <span className="manualpopfr">
      <span
        className="grayfr"
        onContextMenu={(event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
          event.preventDefault();
          setPoints({ x: event.pageX, y: event.pageY });
          handleContextMenu(event);
        }}
      >
        {manual.comment}
      </span>

      <ul
        className="pop"
        style={{
          display: contextOpen ? 'block' : 'none',
          position: 'fixed',
          top: `${points.y}px`,
          left: `${points.x}px`,
        }}
        ref={ref}
      >
        <li style={{ padding: '2px 2px' }} onClick={() => setIsModal(true)}>
          {t('編集')}
        </li>
      </ul>

      <Modal active={isModal} additionalClassName="mtsp" displayCloseButton onClose={() => handleClose()}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <fieldset className="fieldset-reset">
            <div className="formarea1" style={{ marginTop: '10px' }}>
              <label htmlFor="comment">{t('コメント')}</label>
              <textarea rows={10} cols={33} {...register('comment')} />
            </div>

            <div className="btnfr btnfr2 mb0">
              <div>
                <button type="button" className="text-button" onClick={() => handleClose()}>
                  <span className="btn2 mr10 btnbg-g">
                    <span className="modal-close2">{t('キャンセル')}</span>
                  </span>
                </button>
                <span>
                  <input type="submit" value={t('更新').toString()} className="btn1" />
                </span>{' '}
              </div>
            </div>
          </fieldset>
        </form>
      </Modal>
    </span>
  );
}

export { ManualComment };
